export default [
    {
        comment: '',
        error_id: 'T-DSRL-01',
        cumm_error: 15.00,
        data: [
            {cross_section: '4420', error: '25.00', channel: '253.00'},
            {cross_section: '5505', error: '-10.00', channel: '155.00'},
        ]
    },
    {
        comment: '',
        error_id: 'DSRL-02',
        data: [
            {cross_section: '4420', chn: 253.00},
            {cross_section: '5505', chn: 155.00},
        ]
    },
    {
        comment: '',
        error_id: 'DSRL-03',
        data: [
            {cross_section: '4420', chn: 253.00},
            {cross_section: '5505', chn: 155.00},
        ]
    }
]